let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1cYf6")).then(() => parcelRequire('27TU8'));